(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["panstead-protection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('savressa-protection')) {
  class SavressaProtection extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.checkbox = this.querySelector('input');
      this.checkbox?.addEventListener('change', () => this.update(this.checkbox.checked));
      if (!SavressaProtection.unsubscribe && typeof subscribe === 'function') {
        SavressaProtection.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'savressa-protection') document.querySelector('savressa-protection')?.repair();
        });
      }
    }
    async cart() {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }
    sectionTargets() {
      const targets = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
      const items = document.querySelector('cart-items');
      const footer = document.querySelector('#main-cart-footer');
      const itemsId = items?.dataset.id || items?.closest('.shopify-section')?.id.replace('shopify-section-', '');
      if (itemsId) targets.push({ id: itemsId, selector: '#shopify-section-' + itemsId });
      if (footer?.dataset.id) targets.push({ id: footer.dataset.id, selector: '#shopify-section-' + footer.dataset.id });
      return targets;
    }
    setBusy(busy) {
      SavressaProtection.busy = busy;
      document.querySelectorAll('savressa-protection').forEach((element) => {
        element.setAttribute('aria-busy', String(busy));
        const input = element.querySelector('input');
        if (input) input.disabled = busy;
      });
    }
    async repair() {
      if (SavressaProtection.busy) return;
      try {
        const cart = await this.cart();
        const services = cart.items.filter((item) => String(item.product_id) === this.dataset.product);
        const regular = cart.items.filter((item) => String(item.product_id) !== this.dataset.product);
        const quantity = services.reduce((total, item) => total + item.quantity, 0);
        if (quantity && (!regular.length || quantity !== 1)) await this.update(regular.length > 0);
      } catch (error) {
        this.querySelector('.vr-protection-error').textContent = this.dataset.error;
      }
    }
    async update(selected) {
      if (SavressaProtection.busy) return;
      const focusId = this.checkbox.id;
      const oldSelected = !selected;
      const targets = this.sectionTargets();
      this.setBusy(true);
      try {
        const cart = await this.cart();
        const services = cart.items.filter((item) => String(item.product_id) === this.dataset.product);
        const hasMerchandise = cart.items.some((item) => String(item.product_id) !== this.dataset.product);
        selected = selected && hasMerchandise;
        const body = { sections: targets.map((target) => target.id), sections_url: window.location.pathname };
        let route = 'cart/update.js';
        if (selected && services.length === 0) {
          route = 'cart/add.js';
          body.items = [{ id: Number(this.dataset.variant), quantity: 1 }];
        } else {
          body.updates = {};
          services.forEach((item, index) => { body.updates[item.key] = selected && index === 0 ? 1 : 0; });
        }
        const response = await fetch(window.Shopify.routes.root + route, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error('Update failed');
        targets.forEach((target) => {
          const current = document.querySelector(target.selector);
          const parsed = new DOMParser().parseFromString(result.sections[target.id], 'text/html');
          const incoming = parsed.querySelector(target.selector) || parsed.querySelector('.shopify-section');
          if (current && incoming) current.innerHTML = incoming.innerHTML;
        });
        const latest = await this.cart();
        const drawer = document.querySelector('cart-drawer');
        drawer?.classList.toggle('is-empty', latest.item_count === 0);
        document.querySelector('cart-items')?.classList.toggle('is-empty', latest.item_count === 0);
        document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', latest.item_count === 0);
        document.getElementById(focusId)?.focus();
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'savressa-protection', cartData: latest });
      } catch (error) {
        const element = document.getElementById(focusId)?.closest('savressa-protection') || this;
        element.querySelector('input').checked = oldSelected;
        element.querySelector('.vr-protection-error').textContent = this.dataset.error;
      } finally {
        this.setBusy(false);
      }
    }
  }
  customElements.define('savressa-protection', SavressaProtection);
}
  } catch(e) { console.error(e); }
})();

})();
